import React from "react";

import Icon from "../../../../../components/ui/icon/Icon";
import { AdvancedTabsContainer } from "./styles";

const AdvancedTabs = ({ data }) => {
  return (
    <AdvancedTabsContainer>
      {data.icon && <Icon icon={data.icon} size="18px" />}
      {data.title}
    </AdvancedTabsContainer>
  );
};

export default AdvancedTabs;
